import { render, staticRenderFns } from "./BancoDeCartasTREditar.vue?vue&type=template&id=ef56729a"
import script from "./BancoDeCartasTREditar.vue?vue&type=script&lang=js"
export * from "./BancoDeCartasTREditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports